import { BalancoFinanceiroOperacaoCategoriaItem } from "core/features/relatorios/typings/index";
import { View } from "@react-pdf/renderer";
import { commonRelatorioPdfStyles } from "components/Relatorio/styles";
import { PDFTable } from "ui/components/PDF";
import useRelatorioBalancoFinanceiroPdfColumns from "./hooks/useRelatorioBalancoFinanceiroPdfColumns";
import TotalRow from "../TotalRow";

interface PDFRelatorioBalancoFinanceiroItemTableProps {
  item: BalancoFinanceiroOperacaoCategoriaItem;
}

function ItemTable({ item }: PDFRelatorioBalancoFinanceiroItemTableProps) {
  const columns = useRelatorioBalancoFinanceiroPdfColumns({
    breadcrumb: item.breadcrumb,
    nome: item.nome,
  });

  return (
    <View>
      <PDFTable
        data={item.contas}
        columns={columns}
        tableHeaderVariant="invisible"
      />
      <View style={commonRelatorioPdfStyles.itemTableSummary}>
        <TotalRow title="Total" valorTotal={item.total} />
      </View>
    </View>
  );
}

export default ItemTable;
